import { render, staticRenderFns } from "./FbSliderForm.vue?vue&type=template&id=2b54eb16&scoped=true"
import script from "./FbSliderForm.vue?vue&type=script&lang=js"
export * from "./FbSliderForm.vue?vue&type=script&lang=js"
import style0 from "./FbSliderForm.vue?vue&type=style&index=0&id=2b54eb16&prod&lang=scss&scoped=true"
import style1 from "./FbSliderForm.vue?vue&type=style&index=1&id=2b54eb16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b54eb16",
  null
  
)

export default component.exports